import type { FaireProductEntity } from "../../entity_types/product";

export const p_2npnup94ez: FaireProductEntity = {
  token: "p_2npnup94ez",
  type: "product",
  name: "truth for today cards",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/f5c6972ad0a851bd1a856858a3d8ac40d4f82555500cf8f8d2e77a9101db3bce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/02a018d961ea3807674159791db342135a810b8e6ef335d7b99e2560b6941c48.jpeg",
    "https://cdn.faire.com/fastly/129a1bc676a7136bb9f6d2fc4ce321a4dd7624766f4aa3bebd3db9a46e137cf0.jpeg",
    "https://cdn.faire.com/fastly/253d763d7daa136206156820bfdbe1f48484f5d42090d5afe523baeef7d6d47d.jpeg",
    "https://cdn.faire.com/fastly/bd2fcf8ef606bd7ed07cb36cf4dc2d3e00b97f877a2ae0c7c41d09dbfd1bc33f.jpeg",
    "https://cdn.faire.com/fastly/016457d6bf9a23b2fa64834f1ba1df976ed5e870254eb7c409fc3d141209ef63.jpeg",
    "https://cdn.faire.com/fastly/429098a2857c8b4973c410a03281166dd190525e60affed42d33b400cb5f62a9.jpeg",
    "https://cdn.faire.com/fastly/54790eaed07d6100e835607e965cff5ec19cbb79aca4ad175faddf1f70c51988.jpeg",
    "https://cdn.faire.com/fastly/7e7ea7f71f4a80736c4712e8bee564f23201b9d282365daefb028057f801712b.jpeg",
  ],
  priceDollars: 12,
  description:
    "Fill your mind with beauty and truth every day with this set of 31 Truth for Today scripture verse cards.\n\nDisplay in your home for a pretty way to point to Jesus. Use them as daily or weekly memory verse reminders. Share them as encouragement with a friend. Easily used as gift tags, bookmarks, tiny notes and more!\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:46.259Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
